if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      try {
        const formData = new FormData(this.form);
        formData.delete('price');
        formData.append('sections', 'custom-cart-drawer');
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: formData
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || window.cartStrings.error);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { sections: data.sections, open: true }
        }));
      } catch (error) {
        this.handleErrorMessage(error.message || window.cartStrings.error);
      } finally {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

//subscription USPs

document.addEventListener("DOMContentLoaded", function () {
  const script = document.getElementById("SubscriptionUSPS");
  if (!script) return;

  let data;
  try {
    data = JSON.parse(script.innerHTML);
  } catch (e) {
    console.error("Invalid JSON in SubscriptionUSPS:", e);
    return;
  }

  if (!data.usps) return;

  const items = data.usps.split("|").map(item => item.trim());

  // Build the <div class="subscribe-benefits"><ul><li>...</li></ul></div>
  function createBenefitsList() {
    const div = document.createElement("div");
    const ul = document.createElement("ul");
    items.forEach(text => {
      if (text) {
        const li = document.createElement("li");
        li.textContent = text;
        ul.appendChild(li);
      }
    });
    div.appendChild(ul);
    div.classList.add("subscribe-benefits");
    return div;
  }

  const containers = document.querySelectorAll(".subscription-card .content");
  console.log({ containers });

  if (containers.length) {
    containers.forEach(container => {
      const benefitsList = createBenefitsList();
      container.appendChild(benefitsList);
    });
  }
});
